var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 30C7.76 30 10 27.76 10 25V20H5C2.24 20 0 22.24 0 25C0 27.76 2.24 30 5 30Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 12.24 2.24 10 5 10H10V20H5C2.24 20 0 17.76 0 15Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.24 2.24 0 5 0H10V10H5C2.24 10 0 7.76 0 5Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H15C17.76 0 20 2.24 20 5C20 7.76 17.76 10 15 10H10V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15C20 17.76 17.76 20 15 20C12.24 20 10 17.76 10 15C10 12.24 12.24 10 15 10C17.76 10 20 12.24 20 15Z",
    fill: "#1ABCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.5e42f1a0b73336f34118f7b3af921c38.svg";
export { ForwardRef as ReactComponent };